export default __webpack_public_path__ + "static/media/mercedes-s-500.ee824625.png";